var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-select-search',{attrs:{"is-loading":_vm.getLoading,"data":_vm.getStockists.data ?? [],"label":"code","placeholder":_vm.placeholder},on:{"infinite-scroll":_vm.handleInfiniteScroll,"search":_vm.handleSearch,"change":_vm.handleChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }